export default "__VITE_ASSET__BfjTMw$L__"